import React from 'react';

const ThankYouPage = ({ onNavigateBack }) => {
  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center px-4">
      <div className="max-w-md w-full bg-white rounded-lg shadow-md p-8 text-center">
        <div className="mb-6">
          <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
            <svg
              className="w-8 h-8 text-green-600"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M5 13l4 4L19 7"
              />
            </svg>
          </div>
          <h1 className="text-3xl font-bold text-gray-900 mb-2">Thank You!</h1>
          <p className="text-gray-600">
            Your generous contribution has been recorded. We're so grateful for your support 
            in making our honeymoon dreams come true!
          </p>
        </div>

        <div className="bg-primary bg-opacity-10 rounded-lg p-4 mb-6">
          <p className="text-sm text-gray-700">
            We'll send you pictures once we return from our honeymoon. 
            Your gift will help create memories that last a lifetime.
          </p>
        </div>

        <button
          onClick={onNavigateBack}
          className="w-full bg-primary text-white py-3 rounded-md hover:bg-primary-dark transition-colors font-semibold"
        >
          Back to Registry
        </button>
      </div>
    </div>
  );
};

export default ThankYouPage;
